import { compose, withStateHandlers, lifecycle } from 'recompose';

import { getUpcomingDiffTime } from 'shared/utils/dateTimeUtils';

import ExpectedTimer from './ExpectedTimer';


const intervalTime = 1000;


export default compose(
  withStateHandlers(
    { expectedMinutes: null },
    {
      expectedMinutesUpdater:
        (_, { expectedTime }) => () => ({ expectedMinutes: getUpcomingDiffTime(Number(expectedTime.estimatedTimestamp)) }),
    },
  ),
  lifecycle({
    componentDidMount() {
      if (this.props.expectedTime.withTimer) {
        this.props.expectedMinutesUpdater(null, this.props);
        this.timer = setInterval(this.props.expectedMinutesUpdater, intervalTime);
      }
    },

    componentDidUpdate() {
      if (this.props.expectedTime.withTimer && new Date().getTime() > this.props.expectedTime.estimatedTimestamp && this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    componentWillReceiveProps({ expectedTime }) {
      if (expectedTime.estimatedTimestamp !== this.props.expectedTime.estimatedTimestamp &&
        expectedTime.withTimer && !this.timer) {
        this.timer = setInterval(this.props.expectedMinutesUpdater, intervalTime);
      }
    },

    componentWillUnmount() {
      clearInterval(this.timer);
    },
  }),
)(ExpectedTimer);
